/* Social: cambia profilo e video tra TikTok e Instagram */
(function () {
  document.querySelectorAll('[data-ap-social]').forEach(function (s) {
    s.querySelectorAll('[data-ap-piatt]').forEach(function (tab) {
      tab.addEventListener('click', function () {
        var p = tab.dataset.apPiatt;
        s.querySelectorAll('[data-ap-piatt]').forEach(function (t) { t.classList.toggle('is-on', t === tab); t.setAttribute('aria-selected', t === tab); });
        s.querySelectorAll('[data-ap-chi]').forEach(function (c) { c.hidden = c.dataset.apChi !== p; });
        s.querySelectorAll('[data-ap-reels]').forEach(function (r) { r.hidden = r.dataset.apReels !== p; });
        var link = s.querySelector('[data-ap-link]');
        if (link) {
          var nome = p === 'tiktok' ? 'TikTok' : 'Instagram';
          link.href = link.dataset[p] || '#';
          var t = link.querySelector('[data-ap-link-testo]');
          if (t) t.textContent = (t.dataset.modello || '').replace('{social}', nome);
        }
      });
    });
  });

  /* video caricati: parte e si ferma al clic, uno alla volta */
  document.querySelectorAll('[data-ap-video]').forEach(function (box) {
    var v = box.querySelector('video'); if (!v) return;
    box.addEventListener('click', function (e) {
      if (e.target.closest('.ap-soc__apri, .ap-socr__prod')) return;
      if (v.paused) {
        document.querySelectorAll('[data-ap-video] video').forEach(function (o) {
          if (o !== v) { o.pause(); o.currentTime = 0; o.muted = true; o.closest('[data-ap-video]').classList.remove('is-playing'); }
        });
        v.muted = false; v.volume = 1;
        var p = v.play(); if (p && p.catch) p.catch(function () { v.muted = true; v.play(); });
        box.classList.add('is-playing');
      } else { v.pause(); box.classList.remove('is-playing'); }
    });
    v.addEventListener('ended', function () { box.classList.remove('is-playing'); });
  });

  /* la card profilo alta quanto la fila dei video */
  function pareggia() {
    document.querySelectorAll('[data-ap-social]').forEach(function (s) {
      var prof = s.querySelector('.ap-soc__prof'), reels = s.querySelector('[data-ap-reels]:not([hidden])');
      if (!prof || !reels) return;
      if (window.innerWidth > 900) prof.style.height = reels.offsetHeight + 'px'; else prof.style.height = '';
    });
  }
  /* stile video sfalsati: il profumo del video va nel carrello senza uscire dalla pagina */
  document.querySelectorAll('[data-ap-soc-carrello]').forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      e.preventDefault(); e.stopPropagation();
      if (btn.hasAttribute('data-fatto')) { if (window.apCarrello) window.apCarrello.apri(); else window.location.href = '/cart'; return; }
      btn.disabled = true;
      fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: +btn.dataset.apSocCarrello, quantity: 1 }] }) })
        .then(function (r) { if (!r.ok) throw r; return fetch('/cart.js', { headers: { Accept: 'application/json' } }); })
        .then(function (r) { return r.json(); })
        .then(function (c) {
          btn.disabled = false; btn.setAttribute('data-fatto', ''); btn.setAttribute('aria-label', 'Vai al carrello');
          btn.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 12.5l4.5 4.5L19 7.5"/></svg>';
          document.querySelectorAll('cart-icon').forEach(function (el) { if (el.renderCartBubble) el.renderCartBubble(c.item_count); });
          document.dispatchEvent(new CustomEvent('cart:update', { bubbles: true, detail: { data: { source: 'ap-social' } } }));
        })
        .catch(function () { btn.disabled = false; });
    });
  });

  pareggia(); window.addEventListener('resize', pareggia); window.addEventListener('load', pareggia);
  document.querySelectorAll('[data-ap-piatt]').forEach(function (t) { t.addEventListener('click', function () { setTimeout(pareggia, 0); }); });
})();
